import { Well } from './well';

export default Well;
